const { MODULE_ASSET_PREFIX } = require("../../config/constants");

const removeAllTags = (tagName) => {
    var elements = document.getElementsByTagName(tagName);
    var i = elements.length;
    while (i--) {
        elements[i].parentNode.removeChild(elements[i]);
    }
};

const generateScriptId = (identifier, scriptType) => `${MODULE_ASSET_PREFIX}${identifier}-${scriptType}`;

module.exports = { removeAllTags, generateScriptId};
